import cn from 'classnames';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';

import s from './Hero.module.scss';

const Hero = () => {
  return (
    <section className={cn(s.root)}>
      <div className={s.wrapper}>
        <img
          src="https://cdn.cloud.ru/backend/career/circle.svg"
          width={2992}
          height={2992}
          alt="circle"
          className={s.circle}
        />
        <div className={s.content}>
          <h1 className={s.title}>
            <span className={s.text}>Всё </span>
            <span className={s.text}>начинается </span>
            <span className={s.text}>с людей </span>
          </h1>
          <Link withButton href="/vacancies" className={cn(s.link, 'link')}>
            <Button
              tagElement="span"
              className={s.button}
              withSlashes
              analyticsOptions={{
                action: '/vacancies',
                clickZone: 'body',
                clickElement: 'buttonclick',
                clickContent: 'Смотреть все вакансии',
                uniqueId: `banner-Смотреть все вакансии`,
                transitionType: 'inside-link',
                clickZoneCategory: 'site-body',
                transitionTypeMetrics: 'internal',
                transitionUrl: '/career/vacancies',
              }}
            >
              Смотреть все вакансии
            </Button>
          </Link>
        </div>
        <div className={s.imageWrapper}>
          <img
            className={s.image}
            width={732}
            height={600}
            src="https://cdn.cloud.ru/backend/career/main/hero/image.png"
            alt="persons"
          />
        </div>
      </div>
    </section>
  );
};

export { Hero };
